<template>
  <div id="user-edit-tab-info">
    <div id="teacherSignLoadingDiv" class="vs-con-loading__container">
      <div class="vx-row mb-base" v-if="signatureImage">
        <div class="vx-col w-1/4">
          <img class="result" style="width: 100%;" :src="getImgUrl()" alt="">
        </div>
      </div>

      <div class="vx-row mb-base">
        <div class="vx-col w-full">
          <vs-button class="mr-2">
            <clipper-upload v-model="signatureImageData.imgURL">Upload Signature</clipper-upload>
          </vs-button>
          <vs-button v-if="signatureImageData.imgURL != ''" @click.prevent="getResult">Crop image</vs-button>
        </div>
      </div>

      <div class="vx-row w-full">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <clipper-basic class="my-clipper" ref="clipper" :src="signatureImageData.imgURL" preview="my-preview">
            <!-- <div class="placeholder" slot="placeholder">No image</div> -->
          </clipper-basic>
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <img class="result" style="width: 100%;" :src="signatureImageData.image" alt="">
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="mt-8 flex flex-wrap items-center justify-end">
            <vs-button v-if="signatureImageData.image != ''" class="ml-auto mt-2" @click="uploadSignatute_" :disabled="!validateForm">Save Changes</vs-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { RemoveBgResult, RemoveBgError, removeBackgroundFromImageBase64 } from "remove.bg";
import * as fs from "fs";
import { clipperUpload, clipperPreview, clipperBasic } from 'vuejs-clipper'
import moduleUserManagement from '@/store/user-management/moduleUserManagement.js'

export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  components: {
    'clipper-upload' :clipperUpload,
    'clipper-preview' :clipperPreview ,
    'clipper-basic' :clipperBasic ,
  },
  data() {
    return {
      data_local: JSON.parse(JSON.stringify(this.data)),
      signatureImage: null,
      signatureImageData: {
        songs: [],
        image : '',
        imgURL : '',
      },
    }
  },
  computed: {
    validateForm() {
      return !this.errors.any()
    }
  },
  methods: {
    getImgUrl() {
      return this.signatureImage+'?'+Math.random()
    },
    uploadSignatute(){
      const localFile = "./local/file/name.jpg";
      const base64img = this.signatureImageData.image;
      const outputFile = `${__dirname}/out/img-removed-from-file.png`;

      removeBackgroundFromImageBase64({
        base64img,
        apiKey: "GCoWESAgx88pF6TCr7NW1EuB",
        size: "regular",
        type: "product",
        // outputFile
      })
      .then((result) => {
        console.log(`File saved to ${outputFile}`);
        const base64img = result.base64img;
        this.signatureImageData.image = base64img
        console.log(base64img);
      })
      .catch((errors) => {
        console.log(`error saved to`);
        console.log(JSON.stringify(errors));
      });

      // const url = this.signatureImageData.image;
      // const outputFile = `${__dirname}/out/img-removed-from-file.png`;

      // removeBackgroundFromImageFile({
      //   path: url,
      //   apiKey: "GCoWESAgx88pF6TCr7NW1EuB",
      //   size: "regular",
      //   type: "auto",
      //   scale: "50%",
      //   outputFile
      // })
      // .then((result) => {
      //  console.log(`File saved to ${outputFile}`);
      //   const base64img = result.base64img;
      // }).catch((errors) => {
      //   console.log(`error saved to`);
      //  console.log(JSON.stringify(errors));
      // });
      // .then((result: RemoveBgResult) => {
      //   console.log(`File saved to ${outputFile}`);
      //   const base64img = result.base64img;
      // })
      // .catch((errors: Array<RemoveBgError>) => {
      //  console.log(JSON.stringify(errors));
      // });

    },
    uploadSignatute_(){
      this.$vs.loading({
          container: '#teacherSignLoadingDiv',
          scale: 0.6
      })

      let data = {
        teacher_id : this.data_local.id,
        image : this.signatureImageData.image,
      }
      this.$store.dispatch("userManagement/uploadTeacherSignatureImage", data)
        .then(res => { 
          if(res.data.status == 'ok'){
            this.signatureImage = null
            this.signatureImage = res.data.image
          }

          this.$vs.loading.close('#teacherSignLoadingDiv > .con-vs-loading')
        })
        .catch(err => {
          this.$vs.loading.close('#teacherSignLoadingDiv > .con-vs-loading')
        })
    },
    getResult(){
      const canvas = this.$refs.clipper.clip();
      this.signatureImageData.image = canvas.toDataURL("image/png", 1);
    },
    fetch_user_signature() {
      this.$store.dispatch("userManagement/fetchTeacherSignature", this.data_local.id)
        .then(res => { 
          if(res.data.status == 'ok'){
            this.signatureImage = res.data.image
          }
        })
        .catch(err => {
          
        })
    },
  },
  created() {
    if(!moduleUserManagement.isRegistered) {
      this.$store.registerModule('userManagement', moduleUserManagement)
      moduleUserManagement.isRegistered = true
    }

    this.fetch_user_signature()
  }
}
</script>